import { RESET } from '../connection/connection.actionTypes';
import { OfflineAvailabilityActionType } from './offlineAvailability.actionCreators';
import { REGISTER_DATA_BAG, REGISTER_OFFLINE_CALL } from './offlineAvailability.actionTypes';

import { createDataBagState } from 'helper/offlineAvailability';

// Action Types
// ------------------------------------

export type OfflineCallType = {
	action: any;
	type: string;
};

export type OfflineAvailabilityStateType = {
	offlineCalls: Array<OfflineCallType>;
	registeredDataBagCount: number;
} & {
	[DataBagKeyType: string]: boolean;
};

export type RootStateType = {
	offlineAvailability: OfflineAvailabilityStateType;
};

export const initialState: OfflineAvailabilityStateType = createDataBagState({
	offlineCalls: [],
	registeredDataBagCount: 0,
} as any);

export default (state: OfflineAvailabilityStateType = initialState, action: OfflineAvailabilityActionType) => {
	switch (action.type) {
		case RESET as any: // global action
			return initialState;
		case REGISTER_OFFLINE_CALL:
			if (action.call) {
				return {
					...state,
					offlineCalls: state.offlineCalls.concat([action.call]),
				};
			}

			return state;
		case REGISTER_DATA_BAG:
			if (!action.key || state[action.key] === true) {
				return state;
			}

			return {
				...state,
				registeredDataBagCount: state.registeredDataBagCount + 1,
				[action.key]: true,
			};
		default:
			return state;
	}
};
